const shortMonthDateFormatter = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
});

const parseNumericDate = (dateString: string): Date | null => {
  const [month, day, year] = dateString.split('/').map(Number);

  if (!month || !day) {
    return null;
  }

  return new Date(year || new Date().getFullYear(), month - 1, day);
};

const parseIsoDate = (dateString: string): Date | null => {
  const match = dateString.match(/^(\d{4})-(\d{2})-(\d{2})$/);

  if (!match) {
    return null;
  }

  const [, year, month, day] = match.map(Number);
  return new Date(year, month - 1, day);
};

const formatShortMonthDate = (dateString?: string | null): string => {
  if (!dateString) {
    return '--';
  }

  const numericDate = parseNumericDate(dateString);
  const parsedDate = numericDate || parseIsoDate(dateString) || new Date(dateString);

  if (Number.isNaN(parsedDate.getTime())) {
    return dateString;
  }

  return shortMonthDateFormatter.format(parsedDate);
};

export default formatShortMonthDate;
